<template>
  <div id="statistic-container">
    <!-- //main 包导航 -->
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/home">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>统计分析</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <!-- 主题模块 -->
    <div class="main-container">
      <div class="header-container">
        <!-- 第一部分 -->
        <div class="item-container">
          <img src="@/assets/image/homeImg/huanzhe2.png" alt />
          <div class="item-right">
            <p class="item-title">患者数量</p>
            <p class="tag-title">{{ startTime }}~{{ endTime }}</p>
            <p class="tag-title">入组：{{ statAllNum.inGroupPatientNum }}人</p>
            <p class="total-title">
              <span class="cart-font">累计</span>
              <span class="big-font">{{ statAllNum.patientNum }}</span>
              <span class="cart-font">人</span>
            </p>
          </div>
        </div>
        <!-- 第二部分 -->
        <div class="item-container">
          <img src="@/assets/image/homeImg/icon_lcsl.png" alt />
          <div class="item-right">
            <p class="item-title">就诊流程数量</p>
            <p class="tag-title">{{ startTime }}~{{ endTime }}</p>
            <p class="tag-title">
              入组：{{ statAllNum.inGroupPatientItemNum }}个
            </p>
            <p class="total-title">
              <span class="cart-font">累计</span>
              <span class="big-font">{{ statAllNum.patientItemNum }}</span>
              <span class="cart-font">个</span>
            </p>
          </div>
        </div>
        <!-- 第三部分 -->
        <div class="item-container">
          <img src="@/assets/image/homeImg/icon_clsc.png" alt />
          <div class="item-right">
            <p class="item-title">流程平均处理时长</p>
            <p class="tag-title">{{ startTime }}~{{ endTime }}</p>
            <p class="tag-title">
              入组：{{ statAllNum.inGroupPatientAverageSeekTime }}天
            </p>
            <p class="total-title">
              <span class="cart-font">累计</span>
              <span class="big-font">{{ statAllNum.averageSeekTime }}</span>
              <span class="cart-font">天</span>
            </p>
          </div>
        </div>
        <!-- 第四部分 -->
        <div class="item-container">
          <img src="@/assets/image/homeImg/icon_zysl.png" alt />
          <div class="item-right">
            <p class="item-title">累计作业数量</p>
            <p class="tag-title">{{ startTime }}~{{ endTime }}</p>
            <p class="tag-title">
              入组：{{ statAllNum.inGroupJobsNum }}个&nbsp;&nbsp;耗时：{{
                statAllNum.jobAverageSeekTime
              }}天
            </p>
            <p class="total-title">
              <span class="cart-font">累计</span>
              <span class="big-font">{{ statAllNum.jobsNum }}</span>
              <span class="cart-font">个</span>
            </p>
          </div>
        </div>
        <!-- end -->
      </div>

      <!-- 整体概览 -->
      <div class="overview">
        <div class="view-title">整体概览</div>
        <div class="view-container">
          <div class="tool-box map-tool">
            <a-dropdown class="tool-item">
              <a class="ant-dropdown-link" href="javascript:;">
                {{ item3MapDisplayVal }}
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay" @click="ckItem6MapDisplay">
                <a-menu-item v-for="item in dropdownLst3" :key="item.key">
                  <a href="javascript:;">{{ item.value }}</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <a-dropdown class="tool-item">
              <a class="ant-dropdown-link" href="javascript:;">
                {{ item6DropdownVal }}
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay" @click="ckItem6Dropdown">
                <a-menu-item v-for="item in dropdownLst1" :key="item.key">
                  <a href="javascript:;">{{ item.value }}</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <a-range-picker
              :disabledDate="disabledEndDate"
              class="tool-item"
              style="width: 168px"
              @change="onChangeItem6Picker"
              :value="rPrckerVal"
            />
            <div class="tool-item">
              <i
                class="iconfont icon-export xiazai"
                @click="exportStatistics('item6')"
              ></i>
            </div>
            <a-tooltip placement="bottomLeft">
              <template slot="title">
                按照医院统计就诊流程数量(即录入的样本数量)，左右两侧联动展示，左侧为地图形式，右侧为柱状图形式
              </template>
              <a-icon class="tool-item icon-intro" type="question-circle" />
            </a-tooltip>
          </div>
          <a-row>
            <geo-map :params="statOpt" showTitle="true"></geo-map>
          </a-row>
        </div>
      </div>
      <!-- 整体图表 -->
      <div class="chart-container">
        <div class="chart-item">
          <a-row>
            <a-col :span="24">
              <div class="tool-box">
                <a-dropdown class="tool-item">
                  <a class="ant-dropdown-link" href="javascript:;">
                    {{ item3DropdownShowHospital }}
                    <a-icon type="down" />
                  </a>
                  <a-menu
                    slot="overlay"
                    @click="ckItem3DropdownShowHopital"
                    style="height: 400px; overflow: auto"
                  >
                    <a-menu-item key="0">
                      <a href="javascript:;">全部</a>
                    </a-menu-item>
                    <a-menu-item
                      v-for="item in hospitalData"
                      :key="item.deptId"
                    >
                      <a href="javascript:;">{{ item.deptName }}</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
                <a-dropdown class="tool-item">
                  <a class="ant-dropdown-link" href="javascript:;">
                    {{ item3DropdownShowVal }}
                    <a-icon type="down" />
                  </a>
                  <a-menu slot="overlay" @click="ckItem3DropdownShow">
                    <a-menu-item
                      v-for="item in dropdownShowLst1"
                      :key="item.key"
                    >
                      <a href="javascript:;">{{ item.value }}</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
                <a-dropdown class="tool-item">
                  <a class="ant-dropdown-link" href="javascript:;">
                    {{ item3DropdownVal }}
                    <a-icon type="down" />
                  </a>
                  <a-menu slot="overlay" @click="ckItem3Dropdown">
                    <a-menu-item v-for="item in dropdownLst2" :key="item.key">
                      <a href="javascript:;">{{ item.value }}</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
                <a-range-picker
                  :disabledDate="disabledEndDate"
                  class="tool-item"
                  style="width: 198px"
                  @change="onChangeItem3Picker"
                  :value="rPrckerVal3"
                />
                <div class="tool-item">
                  <i
                    class="iconfont icon-export xiazai"
                    @click="exportStatistics('item3')"
                  ></i>
                </div>
                <a-tooltip placement="bottomRight">
                  <template slot="title">
                    <div class="echart-tool-tip">
                      按照医院统计就诊流程的平常处理时长，以每个统计的结束时间来统计个数，横轴为医院，纵轴为时长，单位天
                      <ul class="echart-intro">
                        <li>全流程时长=样本报告上传时间-采样日期的00点</li>
                        <li>
                          测序时长=样本最后一个fq上传完成时间-采样日期的00点
                        </li>
                        <li>云平台时长=作业完成时间-最近一个fq上传完成时间</li>
                        <li>审核时长=报告审核通过时间-作业完成时间</li>
                        <li>报告时长=报告上传时间-审核通过时间</li>
                      </ul>
                    </div>
                  </template>
                  <a-icon class="tool-item icon-intro" type="question-circle" />
                </a-tooltip>
              </div>
              <template v-if="item3Data.seriesData.length == 0">
                <div class="data-none-empty">
                  <a-empty />
                </div>
              </template>
              <template v-else>
                <catetory-item
                  v-if="item3Data.seriesData.length > 0 && !flag3"
                  :id="item3"
                  :catetoryData="item3Data"
                ></catetory-item>
              </template>
            </a-col>
          </a-row>
        </div>
        <div class="chart-item">
          <a-row>
            <a-col :span="11" style="position: relative">
              <div class="tool-box">
                <div class="tool-item customize" @click="customize()">
                  自定义
                </div>
                <div class="tool-item">
                  <i
                    class="iconfont icon-export xiazai"
                    @click="exportStatistics('item4')"
                  ></i>
                </div>
                <a-tooltip placement="bottomRight">
                  <template slot="title">
                    {{ ageTitle }}
                  </template>
                  <a-icon class="tool-item icon-intro" type="question-circle" />
                </a-tooltip>
              </div>
              <template v-if="resFirstAgeNumData.length == 0">
                <div class="data-none-empty">
                  <a-empty />
                </div>
              </template>
              <template v-else>
                <pipe-graph
                  v-if="resFirstAgeNumData.length > 0 && !flag4"
                  :id="item4"
                  :pipeGraphData="resFirstAgeNumData"
                ></pipe-graph>
              </template>
            </a-col>
            <a-col :span="11" :offset="2">
              <div data-id="item1" class="tool-box">
                <a-dropdown class="tool-item">
                  <a class="ant-dropdown-link" href="javascript:;">
                    {{ item1DropdownVal }}
                    <a-icon type="down" />
                  </a>
                  <a-menu slot="overlay" @click="ckItem1Dropdown">
                    <a-menu-item v-for="item in dropdownLst1" :key="item.key">
                      <a href="javascript:;">{{ item.value }}</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
                <div class="tool-item">
                  <i
                    class="iconfont icon-export xiazai"
                    @click="exportStatistics('item1')"
                  ></i>
                </div>
                <a-tooltip placement="bottomRight">
                  <template slot="title">
                    按照测序中心统计就诊流程录入的数量，纵轴为数量，横轴为时间
                  </template>
                  <a-icon class="tool-item icon-intro" type="question-circle" />
                </a-tooltip>
              </div>
              <template v-if="item1Data.name.length == 0">
                <div class="data-none-empty" style="min-height: 450px;">
                  <a-empty />
                </div>
              </template>
              <template v-else>
                <line-test
                  v-if="item1Data.name.length > 0 && !flag1"
                  :id="item1"
                  :lineItemData="item1Data"
                  :lineItemTitle="lineItem1Title"
                ></line-test>
              </template>
            </a-col>
          </a-row>
        </div>
        <div class="chart-item">
          <a-row>
            <a-col :span="24">
              <div data-id="item2" class="tool-box mb-10">
                <a-dropdown class="tool-item">
                  <a class="ant-dropdown-link" href="javascript:;">
                    {{ item2DropdownVal }}
                    <a-icon type="down" />
                  </a>
                  <a-menu slot="overlay" @click="ckItem2Dropdown">
                    <a-menu-item v-for="item in dropdownLst1" :key="item.key">
                      <a href="javascript:;">{{ item.value }}</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
                <a-range-picker
                  :disabledDate="disabledEndDate"
                  class="tool-item"
                  style="width: 198px"
                  @change="onChangeItem2Picker"
                  :value="rPrckerVal2"
                />
                <a-dropdown class="tool-item">
                  <a class="ant-dropdown-link" href="javascript:;">
                    {{ item2PipeDropdownVal }}
                    <a-icon type="down" />
                  </a>
                  <a-menu slot="overlay" @click="ckItem2PipeDropdown">
                    <a-menu-item key="0">
                      <a href="javascript:;">全部</a>
                    </a-menu-item>
                    <a-menu-item
                      v-for="item in dropdownLstPipe"
                      :key="item.name"
                    >
                      <a href="javascript:;">{{ item.name }}</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
                <div class="tool-item">
                  <i
                    class="iconfont icon-export xiazai"
                    @click="exportStatistics('item2')"
                  ></i>
                </div>
                <a-tooltip placement="bottomRight">
                  <template slot="title">
                    按照医院统计作业总数、成功数和失败数，以作业创建时间来统计个数（即上传了fq、分析完成和分析失败的样本数量）
                  </template>
                  <a-icon class="tool-item icon-intro" type="question-circle" />
                </a-tooltip>
              </div>
              <!-- end -->
              <template v-if="item2Data.name.length == 0">
                <div class="data-none-empty">
                  <a-empty />
                </div>
              </template>
              <template v-else>
                <line-test
                  v-if="item2Data.name.length > 0 && !flag2"
                  :id="item2"
                  :lineItemData="item2Data"
                  :lineItemTitle="lineItem2Title"
                ></line-test>
              </template>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <page-model @close="closeModel" :visible="visible">
      <customize
        v-if="visible"
        @close="closeModel"
        :firstAgeData="firstAgeList"
        @getNumByFirstAge="getStatPatientNumByFirstAge"
      ></customize>
      <!-- <edit v-if='visible&&isShowGroup==4' :list='recordList' @close='closeModel'></edit>-->
    </page-model>
  </div>
</template>
<script>
import moment from "moment";
import DistributeEchart from "@/components/homepage/distributeEchart";
import GeoMap from "@/components/echarts/map";
import Catetory from "@/components/echarts/catetory";
import CatetoryItem from "@/components/echarts/catetoryItem";
import LineTest from "@/components/echarts/line";
import PipeGraph from "@/components/echarts/pipeGraph";
import customize from "./customize";

export default {
  data() {
    return {
      dateFormat: "YYYY-MM-DD",
      startTime: "2020-01-01",
      endTime: "",
      rPrckerVal: null,
      rPrckerVal2: null,
      rPrckerVal3: null,
      item1: "charts1",
      lineItem1Title: "就诊流程数量 | 测序中心",
      lineItem2Title: "作业数量 | 云平台",
      hospitalData: [],
      item1Data: {
        name: [],
        tData: [],
        xData: [],
      },
      item2: "charts2",
      item2Data: {
        name: [],
        tData: [],
        xData: [],
      },
      item3: "charts3",
      item3Data: {
        yAxisData: [],
        seriesData: [],
      },
      item4: "charts4",
      item5: "charts5",
      statOpt0: {
        timeType: 2,
      },
      statOpt2: {
        timeType: 2,
        flowName: "",
        startTime: "",
        endTime: "",
      },
      statOpt3: {
        timeType: 1,
        showType: 1,
        hospitalId: 0,
        startTime: "",
        endTime: "",
      },
      statOpt: {
        timeType: 0,
        mapDisplay: 1,
        startTime: "",
        endTime: "",
      },
      item1DropdownVal: "近一月",
      item2DropdownVal: "近一月",
      item2PipeDropdownVal: "全部",
      item3DropdownVal: "近一月",
      item3MapDisplayVal: "组内",
      item6DropdownVal: "全部",
      item3DropdownShowVal: "中位数",
      item3DropdownShowHospital: "全部",
      dropdownLst1: [
        { key: 0, value: "全部" },
        { key: 1, value: "近7天" },
        { key: 2, value: "近一月" },
        { key: 5, value: "近一年" },
      ],
      dropdownShowLst1: [
        { key: 0, value: "平均数" },
        { key: 1, value: "中位数" },
      ],
      dropdownLst2: [
        { key: 0, value: "全部" },
        { key: 1, value: "近一月" },
        { key: 2, value: "近一年" },
      ],
      dropdownLst3: [
        { key: -1, value: "全部" },
        { key: 0, value: "组外" },
        { key: 1, value: "组内" },
      ],
      dropdownLstPipe: [],
      customOpt:
        '{"isDefault": 0, "paramList": ["0~1", "1~3", "4~6", "7~10", "10+"]}',
      customOptBase64: "",
      isDefault: 0,
      resFirstAgeNumData: [],
      firstAgeList: [],
      statAllNum: {},
      visible: false,
      flag: false,
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      ageTitle:
        "统计患者第一次就诊时的年龄，可自定义条件，默认统计条件为：0~0(<1),1~3(>=1and<=3),4~6(>=4and<=6),7~10(>=7and<=10),10+(>10)",
    };
  },
  components: {
    DistributeEchart,
    Catetory,
    LineTest,
    PipeGraph,
    customize,
    CatetoryItem,
    GeoMap,
  },
  mounted() {
    this.endTime = this.moment().format(this.dateFormat);
    this.getStatAllNum(); //统计汇总数量成功
    this.getStatItem3(); //平均处理时长|就诊流程
    this.getStatPatientItemNumByDate(); //就诊流程数量|测序中心
    this.getStatJobsNumByDate(); //作业数量|云平台
    this.getPipelineLst(); //作业数量|云平台-流程列表
    this.getLastFirstAge(); //初诊年龄区间条件
    this.gethospital();
  },
  methods: {
    moment,
    gethospital() {
      this.$get("stat/findHospitalTree", {
        pageSize: 10000,
        deptType: 1,
      }).then((res) => {
        this.hospitalData = res.data.data[0].children;
        console.log("this.hospitalData", this.hospitalData);
      });
    },
    disabledEndDate(current) {
      return current && current > moment().endOf("day");
    },
    exportStatistics(type) {
      let url = "";
      let opt = {};
      let dFilename = "";
      switch (type) {
        case "item1":
          url = "export/exportStatPatientItemNumByDate";
          opt = this.statOpt0;
          dFilename = "就诊流程数量_测序中心";
          break;
        case "item2":
          url = "export/exportStatJobsNumByDate";
          opt = this.statOpt2;
          dFilename = "作业数量_云平台";
          break;
        case "item3":
          url = "export/exportStatPatientItemAvgTimeByHospital";
          opt = this.statOpt3;
          dFilename = "处理时长_就诊流程";
          break;
        case "item4":
          url = "export/exportStatPatientNumByFirstAge";
          opt = { baseParams: this.customOptBase64 };
          dFilename = "患者_初诊年龄";
          break;
        case "item5-1":
          url = "export/exportStatPatientItemNumBySequencingCenter";
          opt = {};
          dFilename = "就诊流程数量_测序公司";
          break;
        case "item5-2":
          url = "export/exportStatSingleItemAvgTimeByCenter";
          opt = {};
          dFilename = "平均处理时长_测序公司";
          break;
        case "item6":
          url = "export";
          opt = this.statOpt;
          dFilename = "样本数量分布_医院";
          break;
      }
      this.$export(url, opt, dFilename);
    },
    getLastFirstAge() {
      this.$get("stat/getLastFirstAge", { isDefault: this.isDefault }).then(
        (res) => {
          if (res.data.code == 1) {
            let resData = res.data.data;
            this.firstAgeList = resData != "" ? JSON.parse(resData) : {};
            this.firstAgeList.isDefault = this.isDefault;
            let firstAgeList = JSON.stringify(this.firstAgeList);
            this.getStatPatientNumByFirstAge(firstAgeList);
          }
        },
        (err) => {
          console.log("getLastFirstAge err", err);
        }
      );
    },
    getStatPatientNumByFirstAge(customOpt) {
      let opt = this.$base64.encode(customOpt);
      this.customOptBase64 = opt;
      this.$get("stat/statPatientNumByFirstAge", { baseParams: opt }).then(
        (res) => {
          if (res.data.code == 1) {
            let resData = res.data.data;
            this.resFirstAgeNumData = resData;
            this.flag4 = false;
          }
        },
        (err) => {
          console.log("statPatientNumByFirstAge err", err);
        }
      );
    },
    getPipelineLst() {
      let $this = this;
      this.$get("cloudPlatformApi/getCloudPlatformProcessList").then(
        (res) => {
          if (res.data.code == 1) {
            let resData = res.data.data;
            this.dropdownLstPipe = resData.records;
          }
        },
        (err) => {
          console.log("getCloudPlatformProcessList err", err);
        }
      );
    },
    getStatAllNum() {
      let $this = this;
      /** "inGroupPatientNum":4, 入组患者数
       * "patientNum":24,  患者数量
       * "inGroupPatientItemNum":28,   入组患者就诊流程数
       * "patientItemNum":42,    患者就诊流程数
       * "averageSeekTime":9.56,   就诊流程平均耗时/天
       * "inGroupPatientAverageSeekTime":9.8, 入组患者就诊流程平均耗时/天
       * "jobsNum":43,     累计作业数
       * "jobAverageSeekTime":0.68  作业处理平均耗时/天
       **/
      this.$get("stat/statAllNum").then(
        (res) => {
          if (res.data.code == 1) {
            this.statAllNum = res.data.data;
          }
        },
        (err) => {
          console.log("getStatAllNum err", err);
        }
      );
    },
    getStatItem3() {
      let $this = this;
      this.$get("stat/statPatientItemAvgTimeByHospital", this.statOpt3).then(
        (res) => {
          if (res.data.code == 1) {
            let resData = res.data.data;
            $this.item3Data.yAxisData.length = 0;
            $this.item3Data.seriesData.length = 0;
            resData.forEach(function (item, i) {
              $this.item3Data.yAxisData.push(item.deptName);
              $this.item3Data.seriesData.push(item);
            });
            this.flag3 = false;
          }
        },
        (err) => {
          console.log("statPatientItemAvgTimeByHospital err", err);
        }
      );
    },
    getStatPatientItemNumByDate() {
      let $this = this;
      this.$get("stat/statPatientItemNumByDate", this.statOpt0).then(
        (res) => {
          if (res.data.code == 1) {
            let resData = res.data.data;
            $this.item1Data.name.length = 0;
            $this.item1Data.tData.length = 0;
            $this.item1Data.xData.length = 0;
            resData.forEach(function (item, i) {
              if (i == 0) {
                item.jsonList.forEach(function (jItem, i) {
                  $this.item1Data.name.push(jItem.deptName);
                });
              }
              $this.item1Data.xData.push(item.createTime);
            });
            $this.item1Data.tData = this.getTData1(
              resData,
              $this.item1Data.name.length
            );
            this.flag1 = false;
          }
        },
        (err) => {
          console.log("statPatientItemNumByDate err", err);
        }
      );
    },
    getStatJobsNumByDate() {
      let $this = this;
      this.$get("stat/statJobsNumByDepts", this.statOpt2).then(
        (res) => {
          if (res.data.code == 1) {
            let resData = res.data.data;
            $this.item2Data.name.length = 0;
            $this.item2Data.tData.length = 0;
            $this.item2Data.xData.length = 0;
            resData.forEach(function (item, i) {
              if (i == 0) {
                item.jsonList.forEach(function (jItem, i) {
                  $this.item2Data.name.push(jItem.chartsName);
                });
              }
              $this.item2Data.xData.push(item.deptName); //deptName
            });
            $this.item2Data.tData = this.getTData2(
              resData,
              $this.item2Data.name.length
            );
            this.flag2 = false;
          }
        },
        (err) => {
          console.log("statJobsNumByDate err", err);
        }
      );
    },
    getTData1(data, jlstLen) {
      let result = [];
      for (let i = 0; i < jlstLen; i++) {
        let tData = [];
        for (let j = 0; j < data.length; j++) {
          tData.push(data[j].jsonList[i].num * 1);
        }
        result.push(tData);
      }
      return result;
    },
    getTData2(data, jlstLen) {
      let result = [];
      for (let i = 0; i < jlstLen; i++) {
        let tData = [];
        for (let j = 0; j < data.length; j++) {
          tData.push(data[j].jsonList[i].jobNum * 1);
        }
        result.push(tData);
      }
      return result;
    },
    closeModel() {
      this.visible = false;
    },
    customize() {
      this.visible = true;
    },
    //就诊流程平均时间
    ckItem3Dropdown({ key }) {
      let $this = this;
      this.dropdownLst2.forEach((item, i) => {
        if (item.key == key) {
          $this.item3DropdownVal = item.value;
        }
      });
      let statOpt = { timeType: key };
      this.statOpt3 = Object.assign({}, this.statOpt3, statOpt);
      this.flag3 = true;
      this.getStatItem3();
    },
    ckItem3DropdownShow({ key }) {
      let $this = this;
      this.dropdownShowLst1.forEach((item, i) => {
        if (item.key == key) {
          $this.item3DropdownShowVal = item.value;
        }
      });
      let statOpt = { showType: key };
      this.statOpt3 = Object.assign({}, this.statOpt3, statOpt);
      this.flag3 = true;
      this.getStatItem3();
    },
    ckItem3DropdownShowHopital({ key }) {
      console.log("keykeykey", key);
      let $this = this;
      if (key == 0) {
        $this.item3DropdownShowHospital = "全部";
      } else {
        this.hospitalData.forEach((item, i) => {
          if (item.deptId == key) {
            $this.item3DropdownShowHospital = item.deptName;
          }
        });
      }
      let statOpt = { hospitalId: key };
      this.statOpt3 = Object.assign({}, this.statOpt3, statOpt);
      this.flag3 = true;
      this.getStatItem3();
    },
    //作业数量 | 云平台 =》查询
    ckItem2Dropdown({ key }) {
      let $this = this;
      this.dropdownLst1.forEach((item, i) => {
        if (item.key == key) {
          $this.item2DropdownVal = item.value;
        }
      });
      let statOpt = { timeType: key, startTime: null, endTime: null };
      this.rPrckerVal2 = null;
      this.statOpt2 = Object.assign({}, this.statOpt2, statOpt);
      this.flag2 = true;
      this.getStatJobsNumByDate();
    },
    //作业数量 | 云平台 =》查询
    ckItem2PipeDropdown({ key }) {
      let $this = this;
      this.dropdownLstPipe.forEach((item, i) => {
        if (item.name == key) {
          $this.item2PipeDropdownVal = item.name;
        }
      });
      let statOpt = { flowName: key };
      if (key == 0) {
        statOpt = { flowName: "" };
        this.item2PipeDropdownVal = "全部";
      }
      this.statOpt2 = Object.assign({}, this.statOpt2, statOpt);
      this.flag2 = true;
      this.getStatJobsNumByDate();
    },
    //就诊流程数量 | 测序中心 =》查询
    ckItem1Dropdown({ key }) {
      let $this = this;
      this.dropdownLst1.forEach((item, i) => {
        if (item.key == key) {
          $this.item1DropdownVal = item.value;
        }
      });
      const statOpt = {
        timeType: key,
      };
      this.statOpt0 = Object.assign({}, this.statOpt0, statOpt);
      this.flag1 = true;
      this.getStatPatientItemNumByDate();
    },
    //患者数量分布 | 医院 =》查询
    ckItem6Dropdown({ key }) {
      let $this = this;
      this.dropdownLst1.forEach((item, i) => {
        if (item.key == key) {
          $this.item6DropdownVal = item.value;
        }
      });
      let statOpt = { timeType: key, startTime: null, endTime: null };
      this.rPrckerVal = null;
      this.statOpt = Object.assign({}, this.statOpt, statOpt);
      this.flag = true;
    },
    ckItem6MapDisplay({ key }) {
      let $this = this;
      this.dropdownLst3.forEach((item, i) => {
        if (item.key == key) {
          $this.item3MapDisplayVal = item.value;
        }
      });
      let statOpt = {
        mapDisplay: key == -1 ? "" : key,
        startTime: null,
        endTime: null,
      };
      this.rPrckerVal = null;
      this.statOpt = Object.assign({}, this.statOpt, statOpt);
      this.flag = true;
    },
    //患者数量分布 | 医院 =》查询
    onChangeItem6Picker(val, dateString) {
      if (dateString.length > 0) {
        this.rPrckerVal = val;
        let statOpt = {
          startTime: dateString[0],
          endTime: dateString[1],
          timeType: 0,
        };
        this.item6DropdownVal = "全部";
        this.statOpt = Object.assign({}, this.statOpt, statOpt);
        this.flag = true;
      }
    },
    //处理时长 | 就诊流程
    onChangeItem3Picker(val, dateString) {
      if (dateString.length > 0) {
        this.rPrckerVal3 = val;
        let statOpt = {
          startTime: dateString[0],
          endTime: dateString[1],
          timeType: 0,
        };
        this.item3DropdownVal = "全部";
        this.statOpt3 = Object.assign({}, this.statOpt3, statOpt);
        this.flag3 = true;
      }
      this.getStatItem3();
    },
    onChangeItem2Picker(val, dateString) {
      if (dateString.length > 0) {
        this.rPrckerVal2 = val;
        let statOpt = {
          startTime: dateString[0],
          endTime: dateString[1],
          timeType: 0,
        };
        this.item2DropdownVal = "全部";
        this.statOpt2 = Object.assign({}, this.statOpt2, statOpt);
        this.flag2 = true;
      }
      this.getStatJobsNumByDate();
    },
  },
};
</script>
<style lang="scss" scoped>
#statistic-container {
  .data-none-empty {
    padding: 80px 0;
    min-height: 350px;
    background-color: #fff;
    /deep/ .ant-empty-image {
      display: block;
    }
    /deep/ .ant-empty-description {
      display: block;
    }
  }
  .main-container {
    padding: 10px 60px;
  }
  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item-container {
    width: 24%;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    padding: 2% 1%;
    margin-right: 1%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 96px;
    }
    .item-right {
      margin-left: 20px;
      .item-title {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
      p {
        margin-bottom: 5px;
      }
      .tag-title {
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 5px;
        color: rgba(164, 164, 164, 1);
      }
      .cart-font {
        font-size: 12px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .big-font {
        font-size: 40px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        font-family: "Helvetica Neue";
        margin: 0 6px;
      }
    }
  }
  .item-container:last-child {
    margin-right: 0;
  }
  //整体概览

  .view-title {
    padding: 17px 0;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(91, 103, 131, 1);
  }
  .view-container {
    position: relative;
  }
  .chart-item {
    margin-bottom: 30px;
    position: relative;
  }
  .tool-tag {
    position: absolute;
    right: 20px;
    top: 25px;
    z-index: 9;
  }
  .tool-box {
    position: absolute;
    right: 20px;
    top: 20px;
    display: flex;
    justify-content: center;
    align-content: center;
    font-size: 12px;
    z-index: 5;
    .xiazai {
      margin-left: 10px;
      cursor: pointer;
    }
    .tool-item {
      margin-left: 15px;
      line-height: 30px;
    }
    .customize {
      width: 62px;
      height: 30px;
      cursor: pointer;
      // line-height: 30px;
      border: 1px solid rgba(229, 231, 232, 1);
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(164, 164, 164, 1);
      text-align: center;
      z-index: 500;
    }
    //  i{
    //    margin-left: 30px;
    //  }
  }
  .map-tool {
    top: 14px;
    right: 18px;
    background: #fff;
    padding-right: 10px;
    ::v-deep .ant-input {
      padding: 0 4px;
      font-size: 12px;
      line-height: 1;
      height: 20px;
    }
    .tool-item {
      margin-left: 10px;
    }
    .xiazai {
      margin-left: 0;
    }
  }
  .mb-10 {
    top: 10px;
  }
  .icon-intro {
    font-size: 16px;
    cursor: pointer;
  }
}

@media all and (max-width: 1400px) {
  #statistic-container .item-container .item-right {
    margin-left: 15px;
  }
  #statistic-container .item-container {
    padding: 2% 1% 1% 1%;
  }
  #statistic-container .item-container img {
    width: 70px;
  }
  #statistic-container .item-container .item-right .big-font {
    font-size: 32px;
  }
  #statistic-container .item-container .item-right .item-title {
    font-size: 14px;
  }
}
</style>
